<ng-container *ngIf="currentStage$ | async as currentStage">
  <fin-cms-global-disruption-banner></fin-cms-global-disruption-banner>
  <fin-header *ngIf="!showBookingHeader"> </fin-header>

  <fcom-booking-header
    *ngIf="showBookingHeader"
    [loggedIn]="(loginStatus$ | async) === LoginStatus.LOGGED_IN"
    [breadcrumbs]="breadcrumbs$ | async"
    [phasesAria]="{
      pastStep: 'phases.aria.previous' | finLocalization,
      currentStep: 'phases.aria.current' | finLocalization,
      futureStep: 'phases.aria.next' | finLocalization,
    }"
    [homeUrl]="homeUrl"
    [showLogin]="true"
    [showBack]="showBack"
    [userName]="profileName$ | async"
    [profileType]="profileType$ | async"
    (menuClick)="toggleMenu()"
    (breadcrumbClick)="navigateToStep($event)"
    (loginClick)="loginDialog.toggleLogin($event)"
    (homeClick)="onHomeClick($event)"
    (backClick)="onBackClick()"
    [propagateBackClick]="true"
  >
  </fcom-booking-header>

  <fin-login-dialog *ngIf="showBookingHeader" [context]="LoginWidgetContext.BOOKING" #loginDialog></fin-login-dialog>
  <fin-upgrade-status-bar *ngIf="showStatusBar"></fin-upgrade-status-bar>

  <div
    [ngClass]="{
      'one-upgrade-flow-wrapper ps-medium-x grey-25-bg pr-large-y': addWrappingStyles,
    }"
  >
    <main
      role="main"
      [ngClass]="{
        'one-upgrade-flow-inner-wrapper': addWrappingStyles,
      }"
    >
      <router-outlet></router-outlet>
      <fin-upgrade-continue-footer *ngIf="showStatusBar"></fin-upgrade-continue-footer>
    </main>
  </div>

  <fin-upgrade-modal></fin-upgrade-modal>
</ng-container>
